import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ArrowRight } from "lucide-react";

export default function Login() {
  const { login, error, setError } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email, password);
    setBusy(false);
    if (ok) navigate("/dashboard");
  };

  return (
    <div className="min-h-[calc(100vh-3.5rem)] bg-white flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <span className="notion-emoji-box callout-blue mx-auto mb-4">👋</span>
          <h1 className="font-serif-h text-3xl font-semibold text-[#37352F] mb-2">Welcome back</h1>
          <p className="text-[#787774] text-sm">Log in to continue scanning.</p>
        </div>

        <form onSubmit={submit} className="space-y-3" data-testid="login-form">
          <div>
            <label className="text-xs font-medium text-[#787774] block mb-1.5">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => { setEmail(e.target.value); setError(""); }}
              data-testid="login-email-input"
              className="w-full bg-white border border-[#EBEBEA] focus:border-[#2383E2] focus:ring-2 focus:ring-[#D4EBF8] rounded-md px-3.5 py-2.5 text-sm outline-none transition"
              placeholder="you@company.com"
            />
          </div>
          <div>
            <label className="text-xs font-medium text-[#787774] block mb-1.5">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(""); }}
              data-testid="login-password-input"
              className="w-full bg-white border border-[#EBEBEA] focus:border-[#2383E2] focus:ring-2 focus:ring-[#D4EBF8] rounded-md px-3.5 py-2.5 text-sm outline-none transition"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <div className="callout-red rounded-md text-[#8B2A20] text-sm px-3.5 py-2.5" data-testid="login-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit-button"
            className="w-full bg-[#2383E2] text-white font-medium py-2.5 rounded-md flex items-center justify-center gap-2 hover:bg-[#1A6FCC] transition-colors disabled:opacity-50 mt-2"
          >
            {busy ? "Signing in…" : <>Sign in <ArrowRight className="w-4 h-4" /></>}
          </button>
        </form>

        <p className="mt-8 text-sm text-[#787774] text-center">
          Don&apos;t have an account? <Link to="/signup" data-testid="login-to-signup-link" className="text-[#2383E2] hover:underline font-medium">Sign up</Link>
        </p>
      </div>
    </div>
  );
}
